import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { NotificationEdit } from '../modal';

export default function reducer(state: NotificationEdit = new NotificationEdit(),
  action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.NOTIFICATION_EDIT_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.NOTIFICATION_EDIT_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.NOTIFICATION_EDIT_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
